import React, { FC } from 'react';

import { NavigateUnexpectedLarge } from './NavigateUnexpectedLarge';
import { NavigateUnexpectedSmall } from './NavigateUnexpectedSmall';

export interface NavigateUnexpectedProps {
  bodyTextReplacement?: string;
}

export const NavigateUnexpected: FC<NavigateUnexpectedProps> = ({
  bodyTextReplacement,
}) => (
  <>
    <NavigateUnexpectedSmall bodyTextReplacement={bodyTextReplacement} />
    <NavigateUnexpectedLarge bodyTextReplacement={bodyTextReplacement} />
  </>
);
